/* tslint:disable */
/* eslint-disable */
/**
 * C24 Community API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AppWidgetsResponse
 */
export interface AppWidgetsResponse {
    /**
     * 
     * @type {AppWidgetsResponseRelevantGroups}
     * @memberof AppWidgetsResponse
     */
    'relevantGroups'?: AppWidgetsResponseRelevantGroups;
    /**
     * 
     * @type {MapPreviewWidget}
     * @memberof AppWidgetsResponse
     */
    'mapPreview'?: MapPreviewWidget;
}
/**
 * Api items for app home relevant groups widget
 * @export
 * @interface AppWidgetsResponseRelevantGroups
 */
export interface AppWidgetsResponseRelevantGroups {
    /**
     * 
     * @type {string}
     * @memberof AppWidgetsResponseRelevantGroups
     */
    'title'?: string;
    /**
     * 
     * @type {Array<RelevantGroup>}
     * @memberof AppWidgetsResponseRelevantGroups
     */
    'groups'?: Array<RelevantGroup>;
}
/**
 * At location group participant statistics object
 * @export
 * @interface AtLocationGroupParticipantStatistics
 */
export interface AtLocationGroupParticipantStatistics {
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerAgeRange'?: string | null;
}
/**
 * 
 * @export
 * @interface AuthChecktokValidate200Response
 */
export interface AuthChecktokValidate200Response {
    /**
     * 
     * @type {string}
     * @memberof AuthChecktokValidate200Response
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof AuthChecktokValidate200Response
     */
    'uuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthChecktokValidate200Response
     */
    'isOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface AuthChecktokValidate550Response
 */
export interface AuthChecktokValidate550Response {
    /**
     * 
     * @type {string}
     * @memberof AuthChecktokValidate550Response
     */
    'error': string;
}
/**
 * chat base image
 * @export
 * @interface BaseImage
 */
export interface BaseImage {
    /**
     * 
     * @type {number}
     * @memberof BaseImage
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseImage
     */
    'url'?: string | null;
}
/**
 * base chat message
 * @export
 * @interface BaseMessage
 */
export interface BaseMessage {
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'key': string;
    /**
     * 
     * @type {BaseMessageCreatedBy}
     * @memberof BaseMessage
     */
    'createdBy': BaseMessageCreatedBy | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof BaseMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof BaseMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof BaseMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isEdited': boolean;
}
/**
 * @type BaseMessageCreatedBy
 * @export
 */
export type BaseMessageCreatedBy = ChatConversationParticipant;

/**
 * 
 * @export
 * @interface BookingInfo
 */
export interface BookingInfo {
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerAgeRange'?: string | null;
}
/**
 * Chat contact object
 * @export
 * @interface ChatContact
 */
export interface ChatContact {
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'lastActionAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'association'?: string;
    /**
     * 
     * @type {UserStatistics}
     * @memberof ChatContact
     */
    'statistics'?: UserStatistics;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface ChatConversationCreate
 */
export interface ChatConversationCreate {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatConversationCreate
     */
    'userUuids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChatConversationCreateImage}
     * @memberof ChatConversationCreate
     */
    'image'?: ChatConversationCreateImage | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatConversationCreate
     */
    'groupIdInitiatedFrom'?: number | null;
}
/**
 * 
 * @export
 * @interface ChatConversationCreateImage
 */
export interface ChatConversationCreateImage {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreateImage
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreateImage
     */
    'bucket'?: string;
}
/**
 * 
 * @export
 * @interface ChatConversationLeave
 */
export interface ChatConversationLeave {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationLeave
     */
    'newOwnerUuid'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatConversationParticipant
 */
export interface ChatConversationParticipant {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'screenName': string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'avatar': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'role': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatConversationParticipant
     */
    'isCurrentUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatConversationParticipant
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'activeState': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'gender': string | null;
}
/**
 * 
 * @export
 * @interface ChatConversationUpdate
 */
export interface ChatConversationUpdate {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChatConversationCreateImage}
     * @memberof ChatConversationUpdate
     */
    'image'?: ChatConversationCreateImage | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatConversationUpdate
     */
    'userUuids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ChatInit
 */
export interface ChatInit {
    /**
     * 
     * @type {string}
     * @memberof ChatInit
     */
    'groupId'?: string;
}
/**
 * chat last message
 * @export
 * @interface ChatLastMessage
 */
export interface ChatLastMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'key'?: string;
    /**
     * 
     * @type {ChatLastMessageOwnedBy}
     * @memberof ChatLastMessage
     */
    'ownedBy'?: ChatLastMessageOwnedBy | null;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatLastMessage
     */
    'sentAt'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatLastMessage
     */
    'updatedAt'?: number | null;
    /**
     * 
     * @type {MessageImages}
     * @memberof ChatLastMessage
     */
    'images'?: MessageImages;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isEdited'?: boolean;
}
/**
 * @type ChatLastMessageOwnedBy
 * @export
 */
export type ChatLastMessageOwnedBy = ChatParticipant;

/**
 * chat message
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'key': string;
    /**
     * 
     * @type {BaseMessageCreatedBy}
     * @memberof ChatMessage
     */
    'createdBy': BaseMessageCreatedBy | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof ChatMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isEdited': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'type': ChatMessageTypeEnum;
    /**
     * 
     * @type {ChatMessageAllOfReferencedMessage}
     * @memberof ChatMessage
     */
    'referencedMessage': ChatMessageAllOfReferencedMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isSeen': boolean;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof ChatMessage
     */
    'seenBy': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {ChatMessageAllOfReactionCount}
     * @memberof ChatMessage
     */
    'reactionCount': ChatMessageAllOfReactionCount | null;
}

export const ChatMessageTypeEnum = {
    SystemConversationArchived: 'system-conversation-archived',
    SystemConversationCreated: 'system-conversation-created',
    SystemConversationReopened: 'system-conversation-reopened',
    SystemConversationRejoined: 'system-conversation-rejoined',
    SystemConversationTitle: 'system-conversation-title',
    SystemOwnerChanged: 'system-owner-changed',
    SystemParticipantLeft: 'system-participant-left',
    SystemParticipantsAdded: 'system-participants-added',
    SystemParticipantsRemoved: 'system-participants-removed',
    Message: 'message'
} as const;

export type ChatMessageTypeEnum = typeof ChatMessageTypeEnum[keyof typeof ChatMessageTypeEnum];

/**
 * 
 * @export
 * @interface ChatMessageAllOfReactionCount
 */
export interface ChatMessageAllOfReactionCount {
    [key: string]: number | any;

    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'dislike'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'like'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'love'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'laugh'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'hushed'?: number;
}
/**
 * @type ChatMessageAllOfReferencedMessage
 * @export
 */
export type ChatMessageAllOfReferencedMessage = ReferencedMessage;

/**
 * 
 * @export
 * @interface ChatMessageBase
 */
export interface ChatMessageBase {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<ChecktokCommentCreateRequestImageListInner>}
     * @memberof ChatMessageBase
     */
    'images'?: Array<ChecktokCommentCreateRequestImageListInner> | null;
}
/**
 * 
 * @export
 * @interface ChatMessageCreate
 */
export interface ChatMessageCreate {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<ChecktokCommentCreateRequestImageListInner>}
     * @memberof ChatMessageCreate
     */
    'images'?: Array<ChecktokCommentCreateRequestImageListInner> | null;
}
/**
 * list of chat messages
 * @export
 * @interface ChatMessageList
 */
export interface ChatMessageList {
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof ChatMessageList
     */
    'messages'?: Array<ChatMessage>;
}
/**
 * 
 * @export
 * @interface ChatMessageMarkAsSeen
 */
export interface ChatMessageMarkAsSeen {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkAsSeen
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkAsSeen
     */
    'messageId'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageUpdate
 */
export interface ChatMessageUpdate {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<ChecktokCommentCreateRequestImageListInner>}
     * @memberof ChatMessageUpdate
     */
    'images'?: Array<ChecktokCommentCreateRequestImageListInner> | null;
}
/**
 * 
 * @export
 * @interface ChatParticipant
 */
export interface ChatParticipant {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'role'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatParticipant
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'gender'?: string | null;
}
/**
 * chat conversation with messages
 * @export
 * @interface ChatWithMessages
 */
export interface ChatWithMessages {
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'key'?: string;
    /**
     * 
     * @type {ChatLastMessageOwnedBy}
     * @memberof ChatWithMessages
     */
    'ownedBy'?: ChatLastMessageOwnedBy | null;
    /**
     * 
     * @type {ChatWithMessagesImage}
     * @memberof ChatWithMessages
     */
    'image'?: ChatWithMessagesImage | null;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatWithMessages
     */
    'participantsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatWithMessages
     */
    'lastSeenTimestamp'?: number | null;
    /**
     * 
     * @type {ChatWithMessagesLastMessage}
     * @memberof ChatWithMessages
     */
    'lastMessage'?: ChatWithMessagesLastMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatWithMessages
     */
    'isNotificationEnabled'?: boolean;
}
/**
 * @type ChatWithMessagesImage
 * @export
 */
export type ChatWithMessagesImage = BaseImage;

/**
 * @type ChatWithMessagesLastMessage
 * @export
 */
export type ChatWithMessagesLastMessage = ChatLastMessage;

/**
 * 
 * @export
 * @interface ChecktokAppHome200Response
 */
export interface ChecktokAppHome200Response {
    /**
     * 
     * @type {string}
     * @memberof ChecktokAppHome200Response
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ChecktokAppHome200Response
     */
    'count': number;
    /**
     * 
     * @type {Array<NotificationMultiUserImageInternalNotification>}
     * @memberof ChecktokAppHome200Response
     */
    'notifications': Array<NotificationMultiUserImageInternalNotification>;
}
/**
 * 
 * @export
 * @interface ChecktokCommentCreateRequest
 */
export interface ChecktokCommentCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentCreateRequest
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentCreateRequest
     */
    'linkoutUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentCreateRequest
     */
    'referencedComment'?: string;
    /**
     * 
     * @type {Array<ChecktokCommentCreateRequestImageListInner>}
     * @memberof ChecktokCommentCreateRequest
     */
    'imageList'?: Array<ChecktokCommentCreateRequestImageListInner>;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentCreateRequest
     */
    'sourceType'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentCreateRequestImageListInner
 */
export interface ChecktokCommentCreateRequestImageListInner {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentCreateRequestImageListInner
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentCreateRequestImageListInner
     */
    'bucket'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentReactionCreate200ResponseInner
 */
export interface ChecktokCommentReactionCreate200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentReactionCreate200ResponseInner
     */
    'message'?: string;
    /**
     * 
     * @type {ChecktokCommentReactionCreate200ResponseInnerCommentReactions}
     * @memberof ChecktokCommentReactionCreate200ResponseInner
     */
    'commentReactions'?: ChecktokCommentReactionCreate200ResponseInnerCommentReactions;
}
/**
 * 
 * @export
 * @interface ChecktokCommentReactionCreate200ResponseInnerCommentReactions
 */
export interface ChecktokCommentReactionCreate200ResponseInnerCommentReactions {
    /**
     * 
     * @type {Array<ChecktokCommentReactionCreate200ResponseInnerCommentReactionsUserReactionsInner>}
     * @memberof ChecktokCommentReactionCreate200ResponseInnerCommentReactions
     */
    'userReactions'?: Array<ChecktokCommentReactionCreate200ResponseInnerCommentReactionsUserReactionsInner>;
    /**
     * 
     * @type {ChecktokCommentReactionCreate200ResponseInnerCommentReactionsReactionCount}
     * @memberof ChecktokCommentReactionCreate200ResponseInnerCommentReactions
     */
    'reactionCount'?: ChecktokCommentReactionCreate200ResponseInnerCommentReactionsReactionCount;
}
/**
 * 
 * @export
 * @interface ChecktokCommentReactionCreate200ResponseInnerCommentReactionsReactionCount
 */
export interface ChecktokCommentReactionCreate200ResponseInnerCommentReactionsReactionCount {
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentReactionCreate200ResponseInnerCommentReactionsReactionCount
     */
    'name'?: number;
}
/**
 * 
 * @export
 * @interface ChecktokCommentReactionCreate200ResponseInnerCommentReactionsUserReactionsInner
 */
export interface ChecktokCommentReactionCreate200ResponseInnerCommentReactionsUserReactionsInner {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentReactionCreate200ResponseInnerCommentReactionsUserReactionsInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentReactionCreate404Response
 */
export interface ChecktokCommentReactionCreate404Response {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentReactionCreate404Response
     */
    'errors': string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentReactionCreateRequest
 */
export interface ChecktokCommentReactionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentReactionCreateRequest
     */
    'reactionTypeName'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentUpdateRequest
 */
export interface ChecktokCommentUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentUpdateRequest
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentUpdateRequest
     */
    'linkoutUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentUpdateRequest
     */
    'referencedComment'?: string;
    /**
     * 
     * @type {Array<ChecktokCommentUpdateRequestImageListInner>}
     * @memberof ChecktokCommentUpdateRequest
     */
    'imageList'?: Array<ChecktokCommentUpdateRequestImageListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentUpdateRequest
     */
    'deleteImage'?: boolean;
}
/**
 * 
 * @export
 * @interface ChecktokCommentUpdateRequestImageListInner
 */
export interface ChecktokCommentUpdateRequestImageListInner {
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentUpdateRequestImageListInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentUpdateRequestImageListInner
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentUpdateRequestImageListInner
     */
    'bucket'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentUpdateRequestImageListInner
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface ChecktokCommentWithCursor
 */
export interface ChecktokCommentWithCursor {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'postId'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ChecktokCommentWithCursor
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isEditorial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentWithCursor
     */
    'timestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isEdited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {ChecktokReferencedComment}
     * @memberof ChecktokCommentWithCursor
     */
    'referencedComment'?: ChecktokReferencedComment;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokCommentWithCursor
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokCommentWithCursor
     */
    'images'?: Array<ChecktokImage>;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'cursor'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentWithSuspendedDeleted
 */
export interface ChecktokCommentWithSuspendedDeleted {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'postId'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isEditorial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'timestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isEdited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {ChecktokReferencedComment}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'referencedComment'?: ChecktokReferencedComment;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'images'?: Array<ChecktokImage>;
}
/**
 * 
 * @export
 * @interface ChecktokImage
 */
export interface ChecktokImage {
    /**
     * 
     * @type {number}
     * @memberof ChecktokImage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChecktokImage
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokImage
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokMedia400Response
 */
export interface ChecktokMedia400Response {
    /**
     * 
     * @type {object}
     * @memberof ChecktokMedia400Response
     */
    'errors': object;
}
/**
 * 
 * @export
 * @interface ChecktokReferencedComment
 */
export interface ChecktokReferencedComment {
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokReferencedComment
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokReferencedComment
     */
    'images'?: Array<ChecktokImage>;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokReferencedComment
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokReferencedComment
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ChecktokReferencedComment
     */
    'image'?: any;
}
/**
 * 
 * @export
 * @interface ChecktokReportClassifications200ResponseInner
 */
export interface ChecktokReportClassifications200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof ChecktokReportClassifications200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReportClassifications200ResponseInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ChecktokReportClassifications400Response
 */
export interface ChecktokReportClassifications400Response {
    /**
     * 
     * @type {ChecktokReportClassifications400ResponseErrors}
     * @memberof ChecktokReportClassifications400Response
     */
    'errors'?: ChecktokReportClassifications400ResponseErrors;
}
/**
 * 
 * @export
 * @interface ChecktokReportClassifications400ResponseErrors
 */
export interface ChecktokReportClassifications400ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof ChecktokReportClassifications400ResponseErrors
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokReportCommentRequest
 */
export interface ChecktokReportCommentRequest {
    /**
     * 
     * @type {number}
     * @memberof ChecktokReportCommentRequest
     */
    'reportClassificationId': number;
}
/**
 * 
 * @export
 * @interface ChecktokStories200Response
 */
export interface ChecktokStories200Response {
    /**
     * 
     * @type {Array<ChecktokStoryForAuthenticatedUser>}
     * @memberof ChecktokStories200Response
     */
    'stories': Array<ChecktokStoryForAuthenticatedUser>;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStories200Response
     */
    'cursor': string;
}
/**
 * 
 * @export
 * @interface ChecktokStoriesArchive200Response
 */
export interface ChecktokStoriesArchive200Response {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoriesArchive200Response
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoriesArchive200Response
     */
    'count': number;
    /**
     * 
     * @type {Array<ChecktokStoryForArchive>}
     * @memberof ChecktokStoriesArchive200Response
     */
    'stories': Array<ChecktokStoryForArchive>;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoriesArchive200Response
     */
    'cursor': string;
}
/**
 * 
 * @export
 * @interface ChecktokStoriesFilter200Response
 */
export interface ChecktokStoriesFilter200Response {
    /**
     * List of tags that can be applied as filters
     * @type {Array<ChecktokStoryFilter>}
     * @memberof ChecktokStoriesFilter200Response
     */
    'tags'?: Array<ChecktokStoryFilter>;
}
/**
 * 
 * @export
 * @interface ChecktokStoriesPreview200Response
 */
export interface ChecktokStoriesPreview200Response {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoriesPreview200Response
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoriesPreview200Response
     */
    'count': number;
    /**
     * 
     * @type {Array<ChecktokStory>}
     * @memberof ChecktokStoriesPreview200Response
     */
    'stories': Array<ChecktokStory>;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoriesPreview200Response
     */
    'cursor': string;
}
/**
 * 
 * @export
 * @interface ChecktokStory
 */
export interface ChecktokStory {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStory
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStory
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStory
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStory
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStory
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryMetadata}
     * @memberof ChecktokStory
     */
    'metadata'?: ChecktokStoryMetadata;
}
/**
 * 
 * @export
 * @interface ChecktokStoryAuthenticatedUserMetadata
 */
export interface ChecktokStoryAuthenticatedUserMetadata {
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'shareCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'userCommented'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'userReaction'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokStoryComments
 */
export interface ChecktokStoryComments {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryComments
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokStoryFilter
 */
export interface ChecktokStoryFilter {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryFilter
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryFilter
     */
    'storyCount'?: number;
}
/**
 * 
 * @export
 * @interface ChecktokStoryForArchive
 */
export interface ChecktokStoryForArchive {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForArchive
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryForArchive
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForArchive
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStoryForArchive
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStoryForArchive
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryMetadata}
     * @memberof ChecktokStoryForArchive
     */
    'metadata'?: ChecktokStoryMetadata;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'watchUrl'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokStoryForAuthenticatedUser
 */
export interface ChecktokStoryForAuthenticatedUser {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryAuthenticatedUserMetadata}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'metadata'?: ChecktokStoryAuthenticatedUserMetadata;
}
/**
 * 
 * @export
 * @interface ChecktokStoryMetadata
 */
export interface ChecktokStoryMetadata {
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'shareCount'?: number;
}
/**
 * 
 * @export
 * @interface ChecktokStoryThumbnails
 */
export interface ChecktokStoryThumbnails {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryThumbnails
     */
    'original'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryThumbnails
     */
    'firstFrame'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokTrackingEvent
 */
export interface ChecktokTrackingEvent {
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'guidDevice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventName'?: ChecktokTrackingEventEventNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventSession'?: string;
    /**
     * 
     * @type {ChecktokTrackingValue}
     * @memberof ChecktokTrackingEvent
     */
    'eventValue'?: ChecktokTrackingValue;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appSession'?: string | null;
}

export const ChecktokTrackingEventEventNameEnum = {
    VideoStart: 'videoStart',
    VideoPause: 'videoPause',
    VideoResume: 'videoResume',
    VideoFinish: 'videoFinish',
    VideoExit: 'videoExit',
    VideoReplay: 'videoReplay',
    VideoCtaClick: 'videoCtaClick'
} as const;

export type ChecktokTrackingEventEventNameEnum = typeof ChecktokTrackingEventEventNameEnum[keyof typeof ChecktokTrackingEventEventNameEnum];

/**
 * 
 * @export
 * @interface ChecktokTrackingValue
 */
export interface ChecktokTrackingValue {
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingValue
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingValue
     */
    'storyId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokUrlShortenRequest
 */
export interface ChecktokUrlShortenRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokUrlShortenRequest
     */
    'storyId'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokUser
 */
export interface ChecktokUser {
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokUser
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'activeState'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokUserProfile200Response
 */
export interface ChecktokUserProfile200Response {
    /**
     * 
     * @type {string}
     * @memberof ChecktokUserProfile200Response
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUserProfile200Response
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUserProfile200Response
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUserProfile200Response
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUserProfile200Response
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUserProfile200Response
     */
    'fallbackAvatar'?: string;
    /**
     * 
     * @type {PrivacySettings}
     * @memberof ChecktokUserProfile200Response
     */
    'privacySettings'?: PrivacySettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof ChecktokUserProfile200Response
     */
    'notificationSettings'?: NotificationSettings;
    /**
     * 
     * @type {SessionUserStatistics}
     * @memberof ChecktokUserProfile200Response
     */
    'statistics'?: SessionUserStatistics;
    /**
     * 
     * @type {ChecktokUserProfile200ResponseAllOfInteractions}
     * @memberof ChecktokUserProfile200Response
     */
    'interactions'?: ChecktokUserProfile200ResponseAllOfInteractions;
}
/**
 * 
 * @export
 * @interface ChecktokUserProfile200ResponseAllOfInteractions
 */
export interface ChecktokUserProfile200ResponseAllOfInteractions {
    /**
     * 
     * @type {Array<object>}
     * @memberof ChecktokUserProfile200ResponseAllOfInteractions
     */
    'polls'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ChecktokUserProfile200ResponseAllOfInteractions
     */
    'reactions'?: Array<object>;
}
/**
 * 
 * @export
 * @interface ChecktokUserReaction200Response
 */
export interface ChecktokUserReaction200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChecktokUserReaction200Response
     */
    'userReactions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CommentDeletedInfo
 */
export interface CommentDeletedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentDeletedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDeletedInfo
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface CommentLocationInfo
 */
export interface CommentLocationInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentLocationInfo
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentLocationInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentLocationInfo
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentLocationInfo
     */
    'geoLong'?: number | null;
}
/**
 * 
 * @export
 * @interface CommentReferencedInfo
 */
export interface CommentReferencedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'askAnswerId'?: string | null;
    /**
     * 
     * @type {UserInfo}
     * @memberof CommentReferencedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof CommentReferencedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'communityLink'?: string;
}
/**
 * 
 * @export
 * @interface CommentUpdatedInfo
 */
export interface CommentUpdatedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'postId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'askAnswerId'?: string | null;
    /**
     * 
     * @type {UserInfo}
     * @memberof CommentUpdatedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {CommentUpdatedInfoLocation}
     * @memberof CommentUpdatedInfo
     */
    'location'?: CommentUpdatedInfoLocation | null;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof CommentUpdatedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<CommentUpdatedInfoReactionCountInner>}
     * @memberof CommentUpdatedInfo
     */
    'reactionCount'?: Array<CommentUpdatedInfoReactionCountInner>;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'communityLink'?: string;
    /**
     * 
     * @type {CommentUpdatedInfoReferencedComment}
     * @memberof CommentUpdatedInfo
     */
    'referencedComment'?: CommentUpdatedInfoReferencedComment | null;
}
/**
 * @type CommentUpdatedInfoLocation
 * @export
 */
export type CommentUpdatedInfoLocation = CommentLocationInfo;

/**
 * 
 * @export
 * @interface CommentUpdatedInfoReactionCountInner
 */
export interface CommentUpdatedInfoReactionCountInner {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfoReactionCountInner
     */
    'reactionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentUpdatedInfoReactionCountInner
     */
    'reactionCount'?: number;
}
/**
 * @type CommentUpdatedInfoReferencedComment
 * @export
 */
export type CommentUpdatedInfoReferencedComment = CommentReferencedInfo;

/**
 * 
 * @export
 * @interface CommunityPointOfInterestGroupCategoryItem
 */
export interface CommunityPointOfInterestGroupCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'icon'?: string;
    /**
     * 
     * @type {Array<CommunityPointOfInterestModel>}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'pointOfInterestModels'?: Array<CommunityPointOfInterestModel>;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestModel
 */
export interface CommunityPointOfInterestModel {
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestModel
     */
    'name'?: string;
    /**
     * 
     * @type {CommunityPointOfInterestTypeModel}
     * @memberof CommunityPointOfInterestModel
     */
    'pointOfInterestTypeModel'?: CommunityPointOfInterestTypeModel;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'distanceInKilometers'?: number | null;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestTypeModel
 */
export interface CommunityPointOfInterestTypeModel {
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'displayName'?: string;
}
/**
 * image external api
 * @export
 * @interface ConversationImageExternal
 */
export interface ConversationImageExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationImageExternal
     */
    'small'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationImageExternal
     */
    'big'?: string | null;
}
/**
 * link for external api
 * @export
 * @interface ConversationLinkExternal
 */
export interface ConversationLinkExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'desktop'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'tablet'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'app'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'tabletapp'?: string;
}
/**
 * chat conversations list
 * @export
 * @interface ConversationList
 */
export interface ConversationList {
    /**
     * 
     * @type {Array<ConversationWithMessages>}
     * @memberof ConversationList
     */
    'result': Array<ConversationWithMessages>;
    /**
     * 
     * @type {ConversationListMeta}
     * @memberof ConversationList
     */
    'meta': ConversationListMeta;
}
/**
 * 
 * @export
 * @interface ConversationListMeta
 */
export interface ConversationListMeta {
    /**
     * 
     * @type {string}
     * @memberof ConversationListMeta
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationListMeta
     */
    'prev'?: string;
}
/**
 * metadata for external api
 * @export
 * @interface ConversationMetadataExternal
 */
export interface ConversationMetadataExternal {
    /**
     * 
     * @type {number}
     * @memberof ConversationMetadataExternal
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationMetadataExternal
     */
    'totalCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationMetadataExternal
     */
    'firstUnreadAnchor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationMetadataExternal
     */
    'latestMessageId'?: string | null;
}
/**
 * conversation related group
 * @export
 * @interface ConversationRelatedGroup
 */
export interface ConversationRelatedGroup {
    /**
     * 
     * @type {number}
     * @memberof ConversationRelatedGroup
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ConversationRelatedGroup
     */
    'name': string;
}
/**
 * chat conversation with last two messages
 * @export
 * @interface ConversationWithLastMessages
 */
export interface ConversationWithLastMessages {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithLastMessages
     */
    'messagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithLastMessages
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof ConversationWithLastMessages
     */
    'lastMessages'?: Array<ChatMessage>;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'displayDate'?: string;
}
/**
 * chat conversation with messages
 * @export
 * @interface ConversationWithMessages
 */
export interface ConversationWithMessages {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'key': string;
    /**
     * 
     * @type {BaseMessageCreatedBy}
     * @memberof ConversationWithMessages
     */
    'ownedBy': BaseMessageCreatedBy | null;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof ConversationWithMessages
     */
    'participants': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'participantsCount': number;
    /**
     * 
     * @type {ConversationWithMessagesImage}
     * @memberof ConversationWithMessages
     */
    'image': ConversationWithMessagesImage;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'type': ConversationWithMessagesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'subtype': ConversationWithMessagesSubtypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConversationWithMessages
     */
    'isOwner': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'messagesCount': number;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'unreadCount': number;
    /**
     * 
     * @type {ConversationWithMessagesLastMessage}
     * @memberof ConversationWithMessages
     */
    'lastMessage': ConversationWithMessagesLastMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConversationWithMessages
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'displayDate': string;
    /**
     * 
     * @type {ConversationWithMessagesRelatedGroup}
     * @memberof ConversationWithMessages
     */
    'relatedGroup': ConversationWithMessagesRelatedGroup | null;
}

export const ConversationWithMessagesTypeEnum = {
    Direct: 'direct',
    Group: 'group',
    Public: 'public'
} as const;

export type ConversationWithMessagesTypeEnum = typeof ConversationWithMessagesTypeEnum[keyof typeof ConversationWithMessagesTypeEnum];
export const ConversationWithMessagesSubtypeEnum = {
    Country: 'country',
    City: 'city',
    Hotel: 'hotel',
    Region: 'region'
} as const;

export type ConversationWithMessagesSubtypeEnum = typeof ConversationWithMessagesSubtypeEnum[keyof typeof ConversationWithMessagesSubtypeEnum];

/**
 * chat conversation with messages
 * @export
 * @interface ConversationWithMessagesExternal
 */
export interface ConversationWithMessagesExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'preview'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'partner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'type'?: string;
    /**
     * 
     * @type {ConversationLinkExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'link'?: ConversationLinkExternal;
    /**
     * 
     * @type {ConversationWithMessagesExternalImage}
     * @memberof ConversationWithMessagesExternal
     */
    'image'?: ConversationWithMessagesExternalImage | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'product'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {ConversationMetadataExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'metaData'?: ConversationMetadataExternal;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversationWithMessagesExternal
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'activity'?: string | null;
}
/**
 * @type ConversationWithMessagesExternalImage
 * @export
 */
export type ConversationWithMessagesExternalImage = ConversationImageExternal;

/**
 * 
 * @export
 * @interface ConversationWithMessagesImage
 */
export interface ConversationWithMessagesImage {
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessagesImage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesImage
     */
    'url'?: string;
}
/**
 * @type ConversationWithMessagesLastMessage
 * @export
 */
export type ConversationWithMessagesLastMessage = ChatMessage;

/**
 * @type ConversationWithMessagesRelatedGroup
 * @export
 */
export type ConversationWithMessagesRelatedGroup = ConversationRelatedGroup;

/**
 * 
 * @export
 * @interface ConversationsListRequest
 */
export interface ConversationsListRequest {
    /**
     * get chats of specific type
     * @type {Array<string>}
     * @memberof ConversationsListRequest
     */
    'types'?: Array<ConversationsListRequestTypesEnum>;
    /**
     * default: 20, max: 50
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'limit'?: number | null;
    /**
     * id of the conversation, will be included
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'after'?: number | null;
    /**
     * id of the conversation, will be included
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'before'?: number | null;
    /**
     * get updates after specified timestamp
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'diff'?: number | null;
    /**
     * get chats with unread messages
     * @type {boolean}
     * @memberof ConversationsListRequest
     */
    'unreadOnly'?: boolean | null;
}

export const ConversationsListRequestTypesEnum = {
    Direct: 'direct',
    Group: 'group',
    Public: 'public'
} as const;

export type ConversationsListRequestTypesEnum = typeof ConversationsListRequestTypesEnum[keyof typeof ConversationsListRequestTypesEnum];

/**
 * 
 * @export
 * @interface CoreAuthorAttributedImageItem
 */
export interface CoreAuthorAttributedImageItem {
    /**
     * 
     * @type {number}
     * @memberof CoreAuthorAttributedImageItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreAuthorAttributedImageItem
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreAuthorAttributedImageItem
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface CoreFile
 */
export interface CoreFile {
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'bucket'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'thumbnail'?: string;
}
/**
 * 
 * @export
 * @interface CoreMediaItem
 */
export interface CoreMediaItem {
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreMediaItem
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'postId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'commentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'cursor'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreMediaItem
     */
    'imageUrl'?: string;
}
/**
 * shortened url
 * @export
 * @interface CoreShortUrl
 */
export interface CoreShortUrl {
    /**
     * 
     * @type {number}
     * @memberof CoreShortUrl
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'long'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'short'?: string;
}
/**
 * Experience information
 * @export
 * @interface Experience
 */
export interface Experience {
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'ratingAverage': number;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'ratingCount': number;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'distanceInKilometers': number | null;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof Experience
     */
    'freeCancellation': boolean;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'travelersInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface ExperiencesList
 */
export interface ExperiencesList {
    /**
     * 
     * @type {Array<Experience>}
     * @memberof ExperiencesList
     */
    'result': Array<Experience>;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'searchLink': string;
}
/**
 * 
 * @export
 * @interface ExternalConversationsListRequest
 */
export interface ExternalConversationsListRequest {
    /**
     * 
     * @type {number}
     * @memberof ExternalConversationsListRequest
     */
    'userId'?: number;
    /**
     * default: 20, max: 200
     * @type {number}
     * @memberof ExternalConversationsListRequest
     */
    'limit'?: number | null;
    /**
     * default: 20, max: 50
     * @type {Array<string>}
     * @memberof ExternalConversationsListRequest
     */
    'orderBy'?: Array<ExternalConversationsListRequestOrderByEnum> | null;
    /**
     * 
     * @type {ExternalConversationsListRequestTags}
     * @memberof ExternalConversationsListRequest
     */
    'tags'?: ExternalConversationsListRequestTags | null;
    /**
     * id of the conversation, will be included
     * @type {string}
     * @memberof ExternalConversationsListRequest
     */
    'after'?: string | null;
    /**
     * id of the conversation, will be included
     * @type {string}
     * @memberof ExternalConversationsListRequest
     */
    'before'?: string | null;
}

export const ExternalConversationsListRequestOrderByEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type ExternalConversationsListRequestOrderByEnum = typeof ExternalConversationsListRequestOrderByEnum[keyof typeof ExternalConversationsListRequestOrderByEnum];

/**
 * tags of a conversation
 * @export
 * @interface ExternalConversationsListRequestTags
 */
export interface ExternalConversationsListRequestTags {
    /**
     * 
     * @type {string}
     * @memberof ExternalConversationsListRequestTags
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalConversationsListRequestTags
     */
    'value'?: string;
}
/**
 * External group object
 * @export
 * @interface ExternalGroup
 */
export interface ExternalGroup {
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'object_key'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'subline'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'travel_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'post_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'image_author_attribution'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExternalGroup
     */
    'avatars'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'cta_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'cta_url'?: string;
}
/**
 * External group object
 * @export
 * @interface ExternalHotelRelatedGroups
 */
export interface ExternalHotelRelatedGroups {
    /**
     * 
     * @type {number}
     * @memberof ExternalHotelRelatedGroups
     */
    'hotel_id'?: number;
    /**
     * 
     * @type {Array<ExternalGroup>}
     * @memberof ExternalHotelRelatedGroups
     */
    'groups'?: Array<ExternalGroup>;
}
/**
 * Generated answer object
 * @export
 * @interface GeneratedAnswer
 */
export interface GeneratedAnswer {
    /**
     * 
     * @type {string}
     * @memberof GeneratedAnswer
     */
    'suggestionText'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'topics'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'suggestedAnswers'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'chips'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GeneratedAnswer
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface GetStory200Response
 */
export interface GetStory200Response {
    /**
     * 
     * @type {ChecktokStoryForAuthenticatedUser}
     * @memberof GetStory200Response
     */
    'story': ChecktokStoryForAuthenticatedUser;
}
/**
 * 
 * @export
 * @interface GroupInfo
 */
export interface GroupInfo {
    /**
     * 
     * @type {number}
     * @memberof GroupInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'travelLocationId'?: string | null;
    /**
     * 
     * @type {Array<PointOfInterestInfo>}
     * @memberof GroupInfo
     */
    'pois'?: Array<PointOfInterestInfo>;
}
/**
 * Group details link type
 * @export
 * @interface GroupLink
 */
export interface GroupLink {
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'url': string;
}
/**
 * At location group participant statistics object
 * @export
 * @interface GroupParticipantStatistics
 */
export interface GroupParticipantStatistics {
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerAgeRange'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'groupsJoinedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'engagementScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'experienceScore'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupParticipantStatistics
     */
    'atLocation'?: boolean;
}
/**
 * Group search item object
 * @export
 * @interface GroupSearchItem
 */
export interface GroupSearchItem {
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'coverImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'popularityTier'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'subline'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'category'?: number | null;
    /**
     * 
     * @type {Array<GroupSearchItemGeoPointInner>}
     * @memberof GroupSearchItem
     */
    'geoPoint'?: Array<GroupSearchItemGeoPointInner> | null;
}
/**
 * 
 * @export
 * @interface GroupSearchItemGeoPointInner
 */
export interface GroupSearchItemGeoPointInner {
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItemGeoPointInner
     */
    'lon'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItemGeoPointInner
     */
    'lat'?: number;
}
/**
 * Group details
 * @export
 * @interface GroupType
 */
export interface GroupType {
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'name': string;
    /**
     * 
     * @type {GroupTypeEnum}
     * @memberof GroupType
     */
    'type': GroupTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'geoLong'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'activeBooking': boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'activeBookingStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'activeBookingLabel': string | null;
    /**
     * 
     * @type {GroupTypeMapCenter}
     * @memberof GroupType
     */
    'mapCenter': GroupTypeMapCenter | null;
    /**
     * 
     * @type {GroupTypeMapCenter}
     * @memberof GroupType
     */
    'mapNe': GroupTypeMapCenter | null;
    /**
     * 
     * @type {GroupTypeMapCenter}
     * @memberof GroupType
     */
    'mapSw': GroupTypeMapCenter | null;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'atLocation': boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'atLocationCount': string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'hasImages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'hasRatings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'isJoined': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'isMember': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'viewCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'postsCount': number;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'parentId': number;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'parentName': string;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'parentPostsCount': number;
    /**
     * 
     * @type {number}
     * @memberof GroupType
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupType
     */
    'starRatingOfficial': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'linkoutUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupType
     */
    'image': string;
    /**
     * 
     * @type {Array<GroupLink>}
     * @memberof GroupType
     */
    'links': Array<GroupLink>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GroupTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY'
} as const;

export type GroupTypeEnum = typeof GroupTypeEnum[keyof typeof GroupTypeEnum];


/**
 * @type GroupTypeMapCenter
 * @export
 */
export type GroupTypeMapCenter = MapCoordinate;

/**
 * chat image
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface ImageInfo
 */
export interface ImageInfo {
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageInfo
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ImageInfo
     */
    'authorAttribution'?: string | null;
}
/**
 * chat init data
 * @export
 * @interface InitData
 */
export interface InitData {
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'chatId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'alreadyVisited'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof InitData
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'chatType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'isNotificationEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'hasAtleastOneMessage'?: boolean;
}
/**
 * map coordinates
 * @export
 * @interface MapCoordinate
 */
export interface MapCoordinate {
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    'long': number;
}
/**
 * 
 * @export
 * @interface MapPreviewConfig
 */
export interface MapPreviewConfig {
    /**
     * 
     * @type {MapPreviewConfigCenter}
     * @memberof MapPreviewConfig
     */
    'center'?: MapPreviewConfigCenter;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfig
     */
    'zoom'?: number;
    /**
     * 
     * @type {MapPreviewConfigBounds}
     * @memberof MapPreviewConfig
     */
    'bounds'?: MapPreviewConfigBounds;
}
/**
 * 
 * @export
 * @interface MapPreviewConfigBounds
 */
export interface MapPreviewConfigBounds {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'n'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'w'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    's'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'e'?: number;
}
/**
 * 
 * @export
 * @interface MapPreviewConfigCenter
 */
export interface MapPreviewConfigCenter {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigCenter
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigCenter
     */
    'geoLong'?: number;
}
/**
 * 
 * @export
 * @interface MapPreviewGroup
 */
export interface MapPreviewGroup {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'geoLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof MapPreviewGroup
     */
    'iconUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface MapPreviewWidget
 */
export interface MapPreviewWidget {
    /**
     * 
     * @type {MapPreviewConfig}
     * @memberof MapPreviewWidget
     */
    'map'?: MapPreviewConfig;
    /**
     * 
     * @type {Array<MapPreviewGroup>}
     * @memberof MapPreviewWidget
     */
    'groups'?: Array<MapPreviewGroup>;
}
/**
 * chat image
 * @export
 * @interface MessageImages
 */
export interface MessageImages {
    /**
     * 
     * @type {Array<Image>}
     * @memberof MessageImages
     */
    'images'?: Array<Image>;
}
/**
 * conversation messages list
 * @export
 * @interface MessageList
 */
export interface MessageList {
    /**
     * 
     * @type {Array<UserChatMessage>}
     * @memberof MessageList
     */
    'result'?: Array<UserChatMessage>;
    /**
     * 
     * @type {number}
     * @memberof MessageList
     */
    'pollingInterval'?: number;
}
/**
 * News widget item
 * @export
 * @interface NewsWidgetItem
 */
export interface NewsWidgetItem {
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'type'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof NewsWidgetItem
     */
    'itemId'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'authorUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'authorGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'subline'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'hasImage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'hasLink'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NewsWidgetItem
     */
    'messageCount'?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof NewsWidgetItem
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof NewsWidgetItem
     */
    'userReactions'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof NewsWidgetItem
     */
    'commentCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationInputNewsFeedInput
 */
export interface NotificationInputNewsFeedInput {
    /**
     * List of newsId\'s (uuid)
     * @type {Array<string>}
     * @memberof NotificationInputNewsFeedInput
     */
    'newsIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface NotificationMultiUserImageInternalNotification
 */
export interface NotificationMultiUserImageInternalNotification {
    /**
     * 
     * @type {number}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'previewImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'classification'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'displayDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'seenAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'updatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationNewsFeedMeta
 */
export interface NotificationNewsFeedMeta {
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'unread'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'page'?: number;
}
/**
 * 
 * @export
 * @interface NotificationNewsFeedNewsFeedAdd
 */
export interface NotificationNewsFeedNewsFeedAdd {
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'news_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'subline'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'image_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'target_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'product'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'is_read'?: boolean;
}
/**
 * User notification settings object
 * @export
 * @interface NotificationSettings
 */
export interface NotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPush'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationComment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationLike'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPost'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPrivateMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationGroupMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPublicMessage'?: boolean;
}
/**
 * 
 * @export
 * @interface PointOfInterestInfo
 */
export interface PointOfInterestInfo {
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PointOfInterestInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PointOfInterestInfo
     */
    'type'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'geoLong'?: number;
}
/**
 * 
 * @export
 * @interface PollOptionInfo
 */
export interface PollOptionInfo {
    /**
     * 
     * @type {number}
     * @memberof PollOptionInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PollOptionInfo
     */
    'content'?: string;
    /**
     * 
     * @type {number}
     * @memberof PollOptionInfo
     */
    'responseCount'?: number;
}
/**
 * 
 * @export
 * @interface PostDeletedInfo
 */
export interface PostDeletedInfo {
    /**
     * 
     * @type {string}
     * @memberof PostDeletedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostDeletedInfo
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInner
 */
export interface PostListResponsePropertyInner {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'id'?: number;
    /**
     * 
     * @type {PostListResponsePropertyInnerGroup}
     * @memberof PostListResponsePropertyInner
     */
    'group'?: PostListResponsePropertyInnerGroup;
    /**
     * 
     * @type {PostListResponsePropertyInnerUser}
     * @memberof PostListResponsePropertyInner
     */
    'user'?: PostListResponsePropertyInnerUser;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'suspendedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'releasedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'releasedBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'location'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'geoLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'commentCount'?: number;
    /**
     * 
     * @type {Array<PostListResponsePropertyInnerImagesInner>}
     * @memberof PostListResponsePropertyInner
     */
    'images'?: Array<PostListResponsePropertyInnerImagesInner>;
    /**
     * 
     * @type {Array<PostListResponsePropertyInnerVideosInner>}
     * @memberof PostListResponsePropertyInner
     */
    'videos'?: Array<PostListResponsePropertyInnerVideosInner>;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerGroup
 */
export interface PostListResponsePropertyInnerGroup {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroup
     * @deprecated
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'image': string;
    /**
     * 
     * @type {PostListResponsePropertyInnerGroupLocation}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'location': PostListResponsePropertyInnerGroupLocation;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerGroupLocation
 */
export interface PostListResponsePropertyInnerGroupLocation {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'geoLat': number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'geoLong': number;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerImagesInner
 */
export interface PostListResponsePropertyInnerImagesInner {
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerImagesInner
     */
    'imageURI'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerUser
 */
export interface PostListResponsePropertyInnerUser {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerUser
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerUser
     */
    'screenName': string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerUser
     */
    'avatar'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerVideosInner
 */
export interface PostListResponsePropertyInnerVideosInner {
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerVideosInner
     */
    'videoUri'?: string;
}
/**
 * 
 * @export
 * @interface PostLocationInfo
 */
export interface PostLocationInfo {
    /**
     * 
     * @type {string}
     * @memberof PostLocationInfo
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostLocationInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostLocationInfo
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PostLocationInfo
     */
    'geoLong'?: number | null;
}
/**
 * 
 * @export
 * @interface PostPollInfo
 */
export interface PostPollInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof PostPollInfo
     */
    'options'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostPollInfo
     */
    'closedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface PostUpdatedInfo
 */
export interface PostUpdatedInfo {
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'askQuestionId'?: string | null;
    /**
     * 
     * @type {GroupInfo}
     * @memberof PostUpdatedInfo
     */
    'group'?: GroupInfo;
    /**
     * 
     * @type {UserInfo}
     * @memberof PostUpdatedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostUpdatedInfo
     */
    'isQuestion'?: boolean;
    /**
     * 
     * @type {PostUpdatedInfoLocation}
     * @memberof PostUpdatedInfo
     */
    'location'?: PostUpdatedInfoLocation | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostUpdatedInfo
     */
    'predictedTags'?: Array<string>;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof PostUpdatedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof PostUpdatedInfo
     */
    'videos'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostUpdatedInfo
     */
    'reactionCount'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {PostUpdatedInfoPoll}
     * @memberof PostUpdatedInfo
     */
    'poll'?: PostUpdatedInfoPoll | null;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'communityLink'?: string;
}
/**
 * @type PostUpdatedInfoLocation
 * @export
 */
export type PostUpdatedInfoLocation = PostLocationInfo;

/**
 * @type PostUpdatedInfoPoll
 * @export
 */
export type PostUpdatedInfoPoll = PostPollInfo;

/**
 * User privacy settings object
 * @export
 * @interface PrivacySettings
 */
export interface PrivacySettings {
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showPostCollection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showInPublicSearch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showInGroupSearch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showProfilePicture'?: boolean;
}
/**
 * Profile object
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'fallbackAvatar'?: string;
    /**
     * 
     * @type {PrivacySettings}
     * @memberof Profile
     */
    'privacySettings'?: PrivacySettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof Profile
     */
    'notificationSettings'?: NotificationSettings;
    /**
     * 
     * @type {SessionUserStatistics}
     * @memberof Profile
     */
    'statistics'?: SessionUserStatistics;
}
/**
 * User public privacy settings object
 * @export
 * @interface PublicPrivacySettings
 */
export interface PublicPrivacySettings {
    /**
     * 
     * @type {boolean}
     * @memberof PublicPrivacySettings
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicPrivacySettings
     */
    'showPostCollection'?: boolean;
}
/**
 * Public profile object
 * @export
 * @interface PublicProfile
 */
export interface PublicProfile {
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {PublicPrivacySettings}
     * @memberof PublicProfile
     */
    'privacySettings'?: PublicPrivacySettings;
    /**
     * 
     * @type {UserStatistics}
     * @memberof PublicProfile
     */
    'statistics'?: UserStatistics;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'isOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface ReactionUpdate
 */
export interface ReactionUpdate {
    /**
     * 
     * @type {string}
     * @memberof ReactionUpdate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReactionUpdate
     */
    'reactionTypeName'?: string;
}
/**
 * referenced chat message
 * @export
 * @interface ReferencedMessage
 */
export interface ReferencedMessage {
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'key': string;
    /**
     * 
     * @type {BaseMessageCreatedBy}
     * @memberof ReferencedMessage
     */
    'createdBy': BaseMessageCreatedBy | null;
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof ReferencedMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof ReferencedMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof ReferencedMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isEdited': boolean;
}
/**
 * 
 * @export
 * @interface RelevantGroup
 */
export interface RelevantGroup {
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'subline'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'travelCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'postCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'image'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelevantGroup
     */
    'avatars'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'ctaText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'ctaUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'imageAuthorAttribution'?: string | null;
}
/**
 * Current session user statistics object
 * @export
 * @interface SessionUserStatistics
 */
export interface SessionUserStatistics {
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'groupsJoinedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'daysActive'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'totalScore'?: number;
}
/**
 * Simple user object
 * @export
 * @interface SimpleUser
 */
export interface SimpleUser {
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'avatar'?: string | null;
}
/**
 * 
 * @export
 * @interface StoryReactionCreate200ResponseInner
 */
export interface StoryReactionCreate200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof StoryReactionCreate200ResponseInner
     */
    'message'?: string;
    /**
     * 
     * @type {ChecktokCommentReactionCreate200ResponseInnerCommentReactions}
     * @memberof StoryReactionCreate200ResponseInner
     */
    'storyReactions'?: ChecktokCommentReactionCreate200ResponseInnerCommentReactions;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TippspielGameResultEnum = {
    Win: 'win',
    Loss: 'loss',
    Draw: 'draw'
} as const;

export type TippspielGameResultEnum = typeof TippspielGameResultEnum[keyof typeof TippspielGameResultEnum];


/**
 * 
 * @export
 * @interface TippspielTeamHistories
 */
export interface TippspielTeamHistories {
    /**
     * 
     * @type {Array<TippspielTeamHistory>}
     * @memberof TippspielTeamHistories
     */
    'teamHomeHistory'?: Array<TippspielTeamHistory>;
    /**
     * 
     * @type {Array<TippspielTeamHistory>}
     * @memberof TippspielTeamHistories
     */
    'teamAwayHistory'?: Array<TippspielTeamHistory>;
}
/**
 * 
 * @export
 * @interface TippspielTeamHistory
 */
export interface TippspielTeamHistory {
    /**
     * 
     * @type {TippspielGameResultEnum}
     * @memberof TippspielTeamHistory
     */
    'gameResult'?: TippspielGameResultEnum;
    /**
     * 
     * @type {string}
     * @memberof TippspielTeamHistory
     */
    'sportradarId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TippspielTeamHistory
     */
    'gameStartsAt'?: string;
}


/**
 * 
 * @export
 * @interface TippspielUserUuidOutput
 */
export interface TippspielUserUuidOutput {
    /**
     * 
     * @type {string}
     * @memberof TippspielUserUuidOutput
     */
    'userId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TippspielUserUuidOutput
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {TippspielUserUuidOutputInteractions}
     * @memberof TippspielUserUuidOutput
     */
    'interactions'?: TippspielUserUuidOutputInteractions;
    /**
     * 
     * @type {boolean}
     * @memberof TippspielUserUuidOutput
     */
    'isOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface TippspielUserUuidOutputInteractions
 */
export interface TippspielUserUuidOutputInteractions {
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'polls'?: any;
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'reactions'?: any;
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'postsComments'?: any;
}
/**
 * Top participant user object
 * @export
 * @interface TopParticipantUser
 */
export interface TopParticipantUser {
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'avatar': string;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'uuid': string;
}
/**
 * User object
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'allowToContact'?: boolean;
}
/**
 * User achievement object
 * @export
 * @interface UserAchievement
 */
export interface UserAchievement {
    /**
     * 
     * @type {string}
     * @memberof UserAchievement
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof UserAchievement
     */
    'criteria': number;
    /**
     * 
     * @type {string}
     * @memberof UserAchievement
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAchievement
     */
    'isEarned': boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAchievement
     */
    'totalUsersCount': number;
}
/**
 * user chat message
 * @export
 * @interface UserChatMessage
 */
export interface UserChatMessage {
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'key': string;
    /**
     * 
     * @type {BaseMessageCreatedBy}
     * @memberof UserChatMessage
     */
    'createdBy': BaseMessageCreatedBy | null;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserChatMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof UserChatMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof UserChatMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isEdited': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'type': UserChatMessageTypeEnum;
    /**
     * 
     * @type {ChatMessageAllOfReferencedMessage}
     * @memberof UserChatMessage
     */
    'referencedMessage': ChatMessageAllOfReferencedMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isSeen': boolean;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof UserChatMessage
     */
    'seenBy': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {ChatMessageAllOfReactionCount}
     * @memberof UserChatMessage
     */
    'reactionCount': ChatMessageAllOfReactionCount | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserChatMessage
     */
    'userReactions'?: Array<string>;
}

export const UserChatMessageTypeEnum = {
    SystemConversationArchived: 'system-conversation-archived',
    SystemConversationCreated: 'system-conversation-created',
    SystemConversationReopened: 'system-conversation-reopened',
    SystemConversationRejoined: 'system-conversation-rejoined',
    SystemConversationTitle: 'system-conversation-title',
    SystemOwnerChanged: 'system-owner-changed',
    SystemParticipantLeft: 'system-participant-left',
    SystemParticipantsAdded: 'system-participants-added',
    SystemParticipantsRemoved: 'system-participants-removed',
    Message: 'message'
} as const;

export type UserChatMessageTypeEnum = typeof UserChatMessageTypeEnum[keyof typeof UserChatMessageTypeEnum];

/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {number}
     * @memberof UserInfo
     */
    'ssoId'?: number;
    /**
     * 
     * @type {Array<BookingInfo>}
     * @memberof UserInfo
     */
    'bookings'?: Array<BookingInfo>;
}
/**
 * User statistics object
 * @export
 * @interface UserStatistics
 */
export interface UserStatistics {
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'groupsJoinedCount'?: number;
}

/**
 * ChecktokApi - axios parameter creator
 * @export
 */
export const ChecktokApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get all stories that follow the preview filter
         * @param {string} [limit] 
         * @param {string} [storyId] 
         * @param {string} [cursor] 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _33819c6d6c6fd583c023fa516b4797ea: async (limit?: string, storyId?: string, cursor?: string, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/checktok/preview-stories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (storyId !== undefined) {
                localVarQueryParameter['storyId'] = storyId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate authentication of the c24 session for Checktok
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authChecktokValidate: async (c24session?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/checktok/auth/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokAppHome: async (c24session: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'c24session' is not null or undefined
            assertParamExists('checktokAppHome', 'c24session', c24session)
            const localVarPath = `/v2/checktok/user/notifications/app-home`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create comment
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentCreateRequest} [checktokCommentCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentCreate: async (uuid: string, checktokCommentCreateRequest?: ChecktokCommentCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('checktokCommentCreate', 'uuid', uuid)
            const localVarPath = `/v2/checktok/story/{uuid}/comment`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checktokCommentCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentDetails: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('checktokCommentDetails', 'uuid', uuid)
            const localVarPath = `/v2/checktok/comments/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create reaction comment
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentReactionCreateRequest} [checktokCommentReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentReactionCreate: async (uuid: string, checktokCommentReactionCreateRequest?: ChecktokCommentReactionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('checktokCommentReactionCreate', 'uuid', uuid)
            const localVarPath = `/v2/checktok/comments/{uuid}/reaction`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checktokCommentReactionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete comment reaction
         * @param {string} uuid id of the comment to remove its reaction
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentReactionDelete: async (uuid: string, reactionTypeName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('checktokCommentReactionDelete', 'uuid', uuid)
            // verify required parameter 'reactionTypeName' is not null or undefined
            assertParamExists('checktokCommentReactionDelete', 'reactionTypeName', reactionTypeName)
            const localVarPath = `/v2/checktok/comments/{uuid}/reaction/{reactionTypeName}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"reactionTypeName"}}`, encodeURIComponent(String(reactionTypeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update comment
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentUpdateRequest} [checktokCommentUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentUpdate: async (uuid: string, checktokCommentUpdateRequest?: ChecktokCommentUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('checktokCommentUpdate', 'uuid', uuid)
            const localVarPath = `/v2/checktok/comments/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checktokCommentUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} media 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokMedia: async (media: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'media' is not null or undefined
            assertParamExists('checktokMedia', 'media', media)
            const localVarPath = `/v2/checktok/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (media !== undefined) { 
                localVarFormParams.append('media', media as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve report classifications by provided report classification type
         * @param {ChecktokReportClassificationsReportClassTypeEnum} reportClassType report classification type
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokReportClassifications: async (reportClassType: ChecktokReportClassificationsReportClassTypeEnum, c24session?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportClassType' is not null or undefined
            assertParamExists('checktokReportClassifications', 'reportClassType', reportClassType)
            const localVarPath = `/v2/checktok/reports/{reportClassType}/classifications`
                .replace(`{${"reportClassType"}}`, encodeURIComponent(String(reportClassType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report on a single comment for breaching the CHECKtok guidelines
         * @param {string} commentId 
         * @param {ChecktokReportCommentRequest} [checktokReportCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokReportComment: async (commentId: string, checktokReportCommentRequest?: ChecktokReportCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('checktokReportComment', 'commentId', commentId)
            const localVarPath = `/v2/checktok/comments/{commentId}/report`
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checktokReportCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all stories
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStories: async (c24session?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/checktok/stories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all stories that follow the archive filter
         * @param {string} [limit] 
         * @param {string} [storyId] 
         * @param {string} [cursor] 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoriesArchive: async (limit?: string, storyId?: string, cursor?: string, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/checktok/stories/archive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (storyId !== undefined) {
                localVarQueryParameter['storyId'] = storyId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of possible filters for stories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoriesFilter: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/checktok/stories/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all stories that follow the preview filter
         * @param {string} [limit] 
         * @param {string} [storyId] 
         * @param {string} [cursor] 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoriesPreview: async (limit?: string, storyId?: string, cursor?: string, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/checktok/stories/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (storyId !== undefined) {
                localVarQueryParameter['storyId'] = storyId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of all comments for a story
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoryComments: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('checktokStoryComments', 'uuid', uuid)
            const localVarPath = `/v2/checktok/stories/{uuid}/comments`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChecktokUrlShortenRequest} checktokUrlShortenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUrlShorten: async (checktokUrlShortenRequest: ChecktokUrlShortenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checktokUrlShortenRequest' is not null or undefined
            assertParamExists('checktokUrlShorten', 'checktokUrlShortenRequest', checktokUrlShortenRequest)
            const localVarPath = `/v2/checktok/url/shorten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checktokUrlShortenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} c24session 
         * @param {string} [limit] 
         * @param {string} [offset] 
         * @param {string} [unread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUserNotifications: async (c24session: string, limit?: string, offset?: string, unread?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'c24session' is not null or undefined
            assertParamExists('checktokUserNotifications', 'c24session', c24session)
            const localVarPath = `/v2/checktok/user/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (unread !== undefined) {
                localVarQueryParameter['unread'] = unread;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show current user profile
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUserProfile: async (c24session: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'c24session' is not null or undefined
            assertParamExists('checktokUserProfile', 'c24session', c24session)
            const localVarPath = `/v2/checktok/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get user\'s reactions to a certain entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUserReaction: async (entityType: string, entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('checktokUserReaction', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('checktokUserReaction', 'entityId', entityId)
            const localVarPath = `/v2/checktok/user/reactions/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a story by its UUID
         * @param {string} uuid uuid of the content
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStory: async (uuid: string, c24session?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getStory', 'uuid', uuid)
            const localVarPath = `/v2/checktok/stories/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create reaction story
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentReactionCreateRequest} [checktokCommentReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyReactionCreate: async (uuid: string, checktokCommentReactionCreateRequest?: ChecktokCommentReactionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('storyReactionCreate', 'uuid', uuid)
            const localVarPath = `/v2/checktok/stories/{uuid}/reaction`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checktokCommentReactionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete story reaction
         * @param {string} uuid uuid of the content
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyReactionDelete: async (uuid: string, reactionTypeName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('storyReactionDelete', 'uuid', uuid)
            // verify required parameter 'reactionTypeName' is not null or undefined
            assertParamExists('storyReactionDelete', 'reactionTypeName', reactionTypeName)
            const localVarPath = `/v2/checktok/stories/{uuid}/reaction/{reactionTypeName}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"reactionTypeName"}}`, encodeURIComponent(String(reactionTypeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * checktok delete comment
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ApiChecktokCommentsDelete: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('v2ApiChecktokCommentsDelete', 'uuid', uuid)
            const localVarPath = `/v2/checktok/comments/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a tracking entry for checktok
         * @param {string} [c24session] 
         * @param {ChecktokTrackingEvent} [checktokTrackingEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ChecktokTracking: async (c24session?: string, checktokTrackingEvent?: ChecktokTrackingEvent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/checktok/tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checktokTrackingEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecktokApi - functional programming interface
 * @export
 */
export const ChecktokApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChecktokApiAxiosParamCreator(configuration)
    return {
        /**
         * get all stories that follow the preview filter
         * @param {string} [limit] 
         * @param {string} [storyId] 
         * @param {string} [cursor] 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _33819c6d6c6fd583c023fa516b4797ea(limit?: string, storyId?: string, cursor?: string, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokStoriesPreview200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._33819c6d6c6fd583c023fa516b4797ea(limit, storyId, cursor, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi._33819c6d6c6fd583c023fa516b4797ea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate authentication of the c24 session for Checktok
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authChecktokValidate(c24session?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthChecktokValidate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authChecktokValidate(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.authChecktokValidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokAppHome(c24session: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokAppHome200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokAppHome(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokAppHome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create comment
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentCreateRequest} [checktokCommentCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokCommentCreate(uuid: string, checktokCommentCreateRequest?: ChecktokCommentCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokCommentCreate(uuid, checktokCommentCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokCommentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokCommentDetails(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokCommentDetails(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokCommentDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create reaction comment
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentReactionCreateRequest} [checktokCommentReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokCommentReactionCreate(uuid: string, checktokCommentReactionCreateRequest?: ChecktokCommentReactionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecktokCommentReactionCreate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokCommentReactionCreate(uuid, checktokCommentReactionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokCommentReactionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete comment reaction
         * @param {string} uuid id of the comment to remove its reaction
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokCommentReactionDelete(uuid: string, reactionTypeName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecktokCommentReactionCreate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokCommentReactionDelete(uuid, reactionTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokCommentReactionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update comment
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentUpdateRequest} [checktokCommentUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokCommentUpdate(uuid: string, checktokCommentUpdateRequest?: ChecktokCommentUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokCommentUpdate(uuid, checktokCommentUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokCommentUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} media 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokMedia(media: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokMedia(media, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve report classifications by provided report classification type
         * @param {ChecktokReportClassificationsReportClassTypeEnum} reportClassType report classification type
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokReportClassifications(reportClassType: ChecktokReportClassificationsReportClassTypeEnum, c24session?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecktokReportClassifications200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokReportClassifications(reportClassType, c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokReportClassifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report on a single comment for breaching the CHECKtok guidelines
         * @param {string} commentId 
         * @param {ChecktokReportCommentRequest} [checktokReportCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokReportComment(commentId: string, checktokReportCommentRequest?: ChecktokReportCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokReportComment(commentId, checktokReportCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokReportComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all stories
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokStories(c24session?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokStories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokStories(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokStories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all stories that follow the archive filter
         * @param {string} [limit] 
         * @param {string} [storyId] 
         * @param {string} [cursor] 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokStoriesArchive(limit?: string, storyId?: string, cursor?: string, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokStoriesArchive200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokStoriesArchive(limit, storyId, cursor, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokStoriesArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of possible filters for stories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokStoriesFilter(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokStoriesFilter200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokStoriesFilter(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokStoriesFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all stories that follow the preview filter
         * @param {string} [limit] 
         * @param {string} [storyId] 
         * @param {string} [cursor] 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokStoriesPreview(limit?: string, storyId?: string, cursor?: string, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokStoriesPreview200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokStoriesPreview(limit, storyId, cursor, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokStoriesPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of all comments for a story
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokStoryComments(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecktokCommentWithSuspendedDeleted>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokStoryComments(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokStoryComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChecktokUrlShortenRequest} checktokUrlShortenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokUrlShorten(checktokUrlShortenRequest: ChecktokUrlShortenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoreShortUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokUrlShorten(checktokUrlShortenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokUrlShorten']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} c24session 
         * @param {string} [limit] 
         * @param {string} [offset] 
         * @param {string} [unread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokUserNotifications(c24session: string, limit?: string, offset?: string, unread?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokAppHome200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokUserNotifications(c24session, limit, offset, unread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokUserNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Show current user profile
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokUserProfile(c24session: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokUserProfile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokUserProfile(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get user\'s reactions to a certain entity
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checktokUserReaction(entityType: string, entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokUserReaction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checktokUserReaction(entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.checktokUserReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a story by its UUID
         * @param {string} uuid uuid of the content
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStory(uuid: string, c24session?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStory(uuid, c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.getStory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create reaction story
         * @param {string} uuid uuid of the content
         * @param {ChecktokCommentReactionCreateRequest} [checktokCommentReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyReactionCreate(uuid: string, checktokCommentReactionCreateRequest?: ChecktokCommentReactionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoryReactionCreate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyReactionCreate(uuid, checktokCommentReactionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.storyReactionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete story reaction
         * @param {string} uuid uuid of the content
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storyReactionDelete(uuid: string, reactionTypeName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoryReactionCreate200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storyReactionDelete(uuid, reactionTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.storyReactionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * checktok delete comment
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ApiChecktokCommentsDelete(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ApiChecktokCommentsDelete(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.v2ApiChecktokCommentsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a tracking entry for checktok
         * @param {string} [c24session] 
         * @param {ChecktokTrackingEvent} [checktokTrackingEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ChecktokTracking(c24session?: string, checktokTrackingEvent?: ChecktokTrackingEvent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ChecktokTracking(c24session, checktokTrackingEvent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecktokApi.v2ChecktokTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChecktokApi - factory interface
 * @export
 */
export const ChecktokApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChecktokApiFp(configuration)
    return {
        /**
         * get all stories that follow the preview filter
         * @param {ChecktokApi33819c6d6c6fd583c023fa516b4797eaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _33819c6d6c6fd583c023fa516b4797ea(requestParameters: ChecktokApi33819c6d6c6fd583c023fa516b4797eaRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokStoriesPreview200Response> {
            return localVarFp._33819c6d6c6fd583c023fa516b4797ea(requestParameters.limit, requestParameters.storyId, requestParameters.cursor, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate authentication of the c24 session for Checktok
         * @param {ChecktokApiAuthChecktokValidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authChecktokValidate(requestParameters: ChecktokApiAuthChecktokValidateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuthChecktokValidate200Response> {
            return localVarFp.authChecktokValidate(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChecktokApiChecktokAppHomeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokAppHome(requestParameters: ChecktokApiChecktokAppHomeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokAppHome200Response> {
            return localVarFp.checktokAppHome(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * create comment
         * @param {ChecktokApiChecktokCommentCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentCreate(requestParameters: ChecktokApiChecktokCommentCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.checktokCommentCreate(requestParameters.uuid, requestParameters.checktokCommentCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChecktokApiChecktokCommentDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentDetails(requestParameters: ChecktokApiChecktokCommentDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.checktokCommentDetails(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * create reaction comment
         * @param {ChecktokApiChecktokCommentReactionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentReactionCreate(requestParameters: ChecktokApiChecktokCommentReactionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChecktokCommentReactionCreate200ResponseInner>> {
            return localVarFp.checktokCommentReactionCreate(requestParameters.uuid, requestParameters.checktokCommentReactionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * delete comment reaction
         * @param {ChecktokApiChecktokCommentReactionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentReactionDelete(requestParameters: ChecktokApiChecktokCommentReactionDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChecktokCommentReactionCreate200ResponseInner>> {
            return localVarFp.checktokCommentReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * update comment
         * @param {ChecktokApiChecktokCommentUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokCommentUpdate(requestParameters: ChecktokApiChecktokCommentUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.checktokCommentUpdate(requestParameters.uuid, requestParameters.checktokCommentUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChecktokApiChecktokMediaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokMedia(requestParameters: ChecktokApiChecktokMediaRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoreFile> {
            return localVarFp.checktokMedia(requestParameters.media, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve report classifications by provided report classification type
         * @param {ChecktokApiChecktokReportClassificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokReportClassifications(requestParameters: ChecktokApiChecktokReportClassificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChecktokReportClassifications200ResponseInner>> {
            return localVarFp.checktokReportClassifications(requestParameters.reportClassType, requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * Report on a single comment for breaching the CHECKtok guidelines
         * @param {ChecktokApiChecktokReportCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokReportComment(requestParameters: ChecktokApiChecktokReportCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.checktokReportComment(requestParameters.commentId, requestParameters.checktokReportCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * get all stories
         * @param {ChecktokApiChecktokStoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStories(requestParameters: ChecktokApiChecktokStoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokStories200Response> {
            return localVarFp.checktokStories(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * get all stories that follow the archive filter
         * @param {ChecktokApiChecktokStoriesArchiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoriesArchive(requestParameters: ChecktokApiChecktokStoriesArchiveRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokStoriesArchive200Response> {
            return localVarFp.checktokStoriesArchive(requestParameters.limit, requestParameters.storyId, requestParameters.cursor, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of possible filters for stories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoriesFilter(options?: RawAxiosRequestConfig): AxiosPromise<ChecktokStoriesFilter200Response> {
            return localVarFp.checktokStoriesFilter(options).then((request) => request(axios, basePath));
        },
        /**
         * get all stories that follow the preview filter
         * @param {ChecktokApiChecktokStoriesPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoriesPreview(requestParameters: ChecktokApiChecktokStoriesPreviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokStoriesPreview200Response> {
            return localVarFp.checktokStoriesPreview(requestParameters.limit, requestParameters.storyId, requestParameters.cursor, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of all comments for a story
         * @param {ChecktokApiChecktokStoryCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokStoryComments(requestParameters: ChecktokApiChecktokStoryCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChecktokCommentWithSuspendedDeleted>> {
            return localVarFp.checktokStoryComments(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChecktokApiChecktokUrlShortenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUrlShorten(requestParameters: ChecktokApiChecktokUrlShortenRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoreShortUrl> {
            return localVarFp.checktokUrlShorten(requestParameters.checktokUrlShortenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChecktokApiChecktokUserNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUserNotifications(requestParameters: ChecktokApiChecktokUserNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokAppHome200Response> {
            return localVarFp.checktokUserNotifications(requestParameters.c24session, requestParameters.limit, requestParameters.offset, requestParameters.unread, options).then((request) => request(axios, basePath));
        },
        /**
         * Show current user profile
         * @param {ChecktokApiChecktokUserProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUserProfile(requestParameters: ChecktokApiChecktokUserProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokUserProfile200Response> {
            return localVarFp.checktokUserProfile(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * get user\'s reactions to a certain entity
         * @param {ChecktokApiChecktokUserReactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checktokUserReaction(requestParameters: ChecktokApiChecktokUserReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokUserReaction200Response> {
            return localVarFp.checktokUserReaction(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a story by its UUID
         * @param {ChecktokApiGetStoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStory(requestParameters: ChecktokApiGetStoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetStory200Response> {
            return localVarFp.getStory(requestParameters.uuid, requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * create reaction story
         * @param {ChecktokApiStoryReactionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyReactionCreate(requestParameters: ChecktokApiStoryReactionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoryReactionCreate200ResponseInner>> {
            return localVarFp.storyReactionCreate(requestParameters.uuid, requestParameters.checktokCommentReactionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * delete story reaction
         * @param {ChecktokApiStoryReactionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storyReactionDelete(requestParameters: ChecktokApiStoryReactionDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StoryReactionCreate200ResponseInner>> {
            return localVarFp.storyReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * checktok delete comment
         * @param {ChecktokApiV2ApiChecktokCommentsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ApiChecktokCommentsDelete(requestParameters: ChecktokApiV2ApiChecktokCommentsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.v2ApiChecktokCommentsDelete(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a tracking entry for checktok
         * @param {ChecktokApiV2ChecktokTrackingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ChecktokTracking(requestParameters: ChecktokApiV2ChecktokTrackingRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2ChecktokTracking(requestParameters.c24session, requestParameters.checktokTrackingEvent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for _33819c6d6c6fd583c023fa516b4797ea operation in ChecktokApi.
 * @export
 * @interface ChecktokApi33819c6d6c6fd583c023fa516b4797eaRequest
 */
export interface ChecktokApi33819c6d6c6fd583c023fa516b4797eaRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApi33819c6d6c6fd583c023fa516b4797ea
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApi33819c6d6c6fd583c023fa516b4797ea
     */
    readonly storyId?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApi33819c6d6c6fd583c023fa516b4797ea
     */
    readonly cursor?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApi33819c6d6c6fd583c023fa516b4797ea
     */
    readonly filter?: string
}

/**
 * Request parameters for authChecktokValidate operation in ChecktokApi.
 * @export
 * @interface ChecktokApiAuthChecktokValidateRequest
 */
export interface ChecktokApiAuthChecktokValidateRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiAuthChecktokValidate
     */
    readonly c24session?: string
}

/**
 * Request parameters for checktokAppHome operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokAppHomeRequest
 */
export interface ChecktokApiChecktokAppHomeRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokAppHome
     */
    readonly c24session: string
}

/**
 * Request parameters for checktokCommentCreate operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokCommentCreateRequest
 */
export interface ChecktokApiChecktokCommentCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiChecktokCommentCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {ChecktokCommentCreateRequest}
     * @memberof ChecktokApiChecktokCommentCreate
     */
    readonly checktokCommentCreateRequest?: ChecktokCommentCreateRequest
}

/**
 * Request parameters for checktokCommentDetails operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokCommentDetailsRequest
 */
export interface ChecktokApiChecktokCommentDetailsRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiChecktokCommentDetails
     */
    readonly uuid: string
}

/**
 * Request parameters for checktokCommentReactionCreate operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokCommentReactionCreateRequest
 */
export interface ChecktokApiChecktokCommentReactionCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiChecktokCommentReactionCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {ChecktokCommentReactionCreateRequest}
     * @memberof ChecktokApiChecktokCommentReactionCreate
     */
    readonly checktokCommentReactionCreateRequest?: ChecktokCommentReactionCreateRequest
}

/**
 * Request parameters for checktokCommentReactionDelete operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokCommentReactionDeleteRequest
 */
export interface ChecktokApiChecktokCommentReactionDeleteRequest {
    /**
     * id of the comment to remove its reaction
     * @type {string}
     * @memberof ChecktokApiChecktokCommentReactionDelete
     */
    readonly uuid: string

    /**
     * reaction type name to react with
     * @type {string}
     * @memberof ChecktokApiChecktokCommentReactionDelete
     */
    readonly reactionTypeName: string
}

/**
 * Request parameters for checktokCommentUpdate operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokCommentUpdateRequest
 */
export interface ChecktokApiChecktokCommentUpdateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiChecktokCommentUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {ChecktokCommentUpdateRequest}
     * @memberof ChecktokApiChecktokCommentUpdate
     */
    readonly checktokCommentUpdateRequest?: ChecktokCommentUpdateRequest
}

/**
 * Request parameters for checktokMedia operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokMediaRequest
 */
export interface ChecktokApiChecktokMediaRequest {
    /**
     * 
     * @type {File}
     * @memberof ChecktokApiChecktokMedia
     */
    readonly media: File
}

/**
 * Request parameters for checktokReportClassifications operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokReportClassificationsRequest
 */
export interface ChecktokApiChecktokReportClassificationsRequest {
    /**
     * report classification type
     * @type {'GENERAL' | 'CONTENT' | 'USER'}
     * @memberof ChecktokApiChecktokReportClassifications
     */
    readonly reportClassType: ChecktokReportClassificationsReportClassTypeEnum

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokReportClassifications
     */
    readonly c24session?: string
}

/**
 * Request parameters for checktokReportComment operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokReportCommentRequest
 */
export interface ChecktokApiChecktokReportCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokReportComment
     */
    readonly commentId: string

    /**
     * 
     * @type {ChecktokReportCommentRequest}
     * @memberof ChecktokApiChecktokReportComment
     */
    readonly checktokReportCommentRequest?: ChecktokReportCommentRequest
}

/**
 * Request parameters for checktokStories operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokStoriesRequest
 */
export interface ChecktokApiChecktokStoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStories
     */
    readonly c24session?: string
}

/**
 * Request parameters for checktokStoriesArchive operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokStoriesArchiveRequest
 */
export interface ChecktokApiChecktokStoriesArchiveRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesArchive
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesArchive
     */
    readonly storyId?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesArchive
     */
    readonly cursor?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesArchive
     */
    readonly filter?: string
}

/**
 * Request parameters for checktokStoriesPreview operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokStoriesPreviewRequest
 */
export interface ChecktokApiChecktokStoriesPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesPreview
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesPreview
     */
    readonly storyId?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesPreview
     */
    readonly cursor?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokStoriesPreview
     */
    readonly filter?: string
}

/**
 * Request parameters for checktokStoryComments operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokStoryCommentsRequest
 */
export interface ChecktokApiChecktokStoryCommentsRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiChecktokStoryComments
     */
    readonly uuid: string
}

/**
 * Request parameters for checktokUrlShorten operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokUrlShortenRequest
 */
export interface ChecktokApiChecktokUrlShortenRequest {
    /**
     * 
     * @type {ChecktokUrlShortenRequest}
     * @memberof ChecktokApiChecktokUrlShorten
     */
    readonly checktokUrlShortenRequest: ChecktokUrlShortenRequest
}

/**
 * Request parameters for checktokUserNotifications operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokUserNotificationsRequest
 */
export interface ChecktokApiChecktokUserNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokUserNotifications
     */
    readonly c24session: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokUserNotifications
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokUserNotifications
     */
    readonly offset?: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokUserNotifications
     */
    readonly unread?: string
}

/**
 * Request parameters for checktokUserProfile operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokUserProfileRequest
 */
export interface ChecktokApiChecktokUserProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokUserProfile
     */
    readonly c24session: string
}

/**
 * Request parameters for checktokUserReaction operation in ChecktokApi.
 * @export
 * @interface ChecktokApiChecktokUserReactionRequest
 */
export interface ChecktokApiChecktokUserReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokUserReaction
     */
    readonly entityType: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiChecktokUserReaction
     */
    readonly entityId: string
}

/**
 * Request parameters for getStory operation in ChecktokApi.
 * @export
 * @interface ChecktokApiGetStoryRequest
 */
export interface ChecktokApiGetStoryRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiGetStory
     */
    readonly uuid: string

    /**
     * 
     * @type {string}
     * @memberof ChecktokApiGetStory
     */
    readonly c24session?: string
}

/**
 * Request parameters for storyReactionCreate operation in ChecktokApi.
 * @export
 * @interface ChecktokApiStoryReactionCreateRequest
 */
export interface ChecktokApiStoryReactionCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiStoryReactionCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {ChecktokCommentReactionCreateRequest}
     * @memberof ChecktokApiStoryReactionCreate
     */
    readonly checktokCommentReactionCreateRequest?: ChecktokCommentReactionCreateRequest
}

/**
 * Request parameters for storyReactionDelete operation in ChecktokApi.
 * @export
 * @interface ChecktokApiStoryReactionDeleteRequest
 */
export interface ChecktokApiStoryReactionDeleteRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiStoryReactionDelete
     */
    readonly uuid: string

    /**
     * reaction type name to react with
     * @type {string}
     * @memberof ChecktokApiStoryReactionDelete
     */
    readonly reactionTypeName: string
}

/**
 * Request parameters for v2ApiChecktokCommentsDelete operation in ChecktokApi.
 * @export
 * @interface ChecktokApiV2ApiChecktokCommentsDeleteRequest
 */
export interface ChecktokApiV2ApiChecktokCommentsDeleteRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof ChecktokApiV2ApiChecktokCommentsDelete
     */
    readonly uuid: string
}

/**
 * Request parameters for v2ChecktokTracking operation in ChecktokApi.
 * @export
 * @interface ChecktokApiV2ChecktokTrackingRequest
 */
export interface ChecktokApiV2ChecktokTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof ChecktokApiV2ChecktokTracking
     */
    readonly c24session?: string

    /**
     * 
     * @type {ChecktokTrackingEvent}
     * @memberof ChecktokApiV2ChecktokTracking
     */
    readonly checktokTrackingEvent?: ChecktokTrackingEvent
}

/**
 * ChecktokApi - object-oriented interface
 * @export
 * @class ChecktokApi
 * @extends {BaseAPI}
 */
export class ChecktokApi extends BaseAPI {
    /**
     * get all stories that follow the preview filter
     * @param {ChecktokApi33819c6d6c6fd583c023fa516b4797eaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public _33819c6d6c6fd583c023fa516b4797ea(requestParameters: ChecktokApi33819c6d6c6fd583c023fa516b4797eaRequest = {}, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration)._33819c6d6c6fd583c023fa516b4797ea(requestParameters.limit, requestParameters.storyId, requestParameters.cursor, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate authentication of the c24 session for Checktok
     * @param {ChecktokApiAuthChecktokValidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public authChecktokValidate(requestParameters: ChecktokApiAuthChecktokValidateRequest = {}, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).authChecktokValidate(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChecktokApiChecktokAppHomeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokAppHome(requestParameters: ChecktokApiChecktokAppHomeRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokAppHome(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create comment
     * @param {ChecktokApiChecktokCommentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokCommentCreate(requestParameters: ChecktokApiChecktokCommentCreateRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokCommentCreate(requestParameters.uuid, requestParameters.checktokCommentCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChecktokApiChecktokCommentDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokCommentDetails(requestParameters: ChecktokApiChecktokCommentDetailsRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokCommentDetails(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create reaction comment
     * @param {ChecktokApiChecktokCommentReactionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokCommentReactionCreate(requestParameters: ChecktokApiChecktokCommentReactionCreateRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokCommentReactionCreate(requestParameters.uuid, requestParameters.checktokCommentReactionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete comment reaction
     * @param {ChecktokApiChecktokCommentReactionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokCommentReactionDelete(requestParameters: ChecktokApiChecktokCommentReactionDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokCommentReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update comment
     * @param {ChecktokApiChecktokCommentUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokCommentUpdate(requestParameters: ChecktokApiChecktokCommentUpdateRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokCommentUpdate(requestParameters.uuid, requestParameters.checktokCommentUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChecktokApiChecktokMediaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokMedia(requestParameters: ChecktokApiChecktokMediaRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokMedia(requestParameters.media, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve report classifications by provided report classification type
     * @param {ChecktokApiChecktokReportClassificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokReportClassifications(requestParameters: ChecktokApiChecktokReportClassificationsRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokReportClassifications(requestParameters.reportClassType, requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report on a single comment for breaching the CHECKtok guidelines
     * @param {ChecktokApiChecktokReportCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokReportComment(requestParameters: ChecktokApiChecktokReportCommentRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokReportComment(requestParameters.commentId, requestParameters.checktokReportCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all stories
     * @param {ChecktokApiChecktokStoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokStories(requestParameters: ChecktokApiChecktokStoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokStories(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all stories that follow the archive filter
     * @param {ChecktokApiChecktokStoriesArchiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokStoriesArchive(requestParameters: ChecktokApiChecktokStoriesArchiveRequest = {}, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokStoriesArchive(requestParameters.limit, requestParameters.storyId, requestParameters.cursor, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of possible filters for stories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokStoriesFilter(options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokStoriesFilter(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all stories that follow the preview filter
     * @param {ChecktokApiChecktokStoriesPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokStoriesPreview(requestParameters: ChecktokApiChecktokStoriesPreviewRequest = {}, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokStoriesPreview(requestParameters.limit, requestParameters.storyId, requestParameters.cursor, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of all comments for a story
     * @param {ChecktokApiChecktokStoryCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokStoryComments(requestParameters: ChecktokApiChecktokStoryCommentsRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokStoryComments(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChecktokApiChecktokUrlShortenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokUrlShorten(requestParameters: ChecktokApiChecktokUrlShortenRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokUrlShorten(requestParameters.checktokUrlShortenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChecktokApiChecktokUserNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokUserNotifications(requestParameters: ChecktokApiChecktokUserNotificationsRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokUserNotifications(requestParameters.c24session, requestParameters.limit, requestParameters.offset, requestParameters.unread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show current user profile
     * @param {ChecktokApiChecktokUserProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokUserProfile(requestParameters: ChecktokApiChecktokUserProfileRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokUserProfile(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get user\'s reactions to a certain entity
     * @param {ChecktokApiChecktokUserReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public checktokUserReaction(requestParameters: ChecktokApiChecktokUserReactionRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).checktokUserReaction(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a story by its UUID
     * @param {ChecktokApiGetStoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public getStory(requestParameters: ChecktokApiGetStoryRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).getStory(requestParameters.uuid, requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create reaction story
     * @param {ChecktokApiStoryReactionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public storyReactionCreate(requestParameters: ChecktokApiStoryReactionCreateRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).storyReactionCreate(requestParameters.uuid, requestParameters.checktokCommentReactionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete story reaction
     * @param {ChecktokApiStoryReactionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public storyReactionDelete(requestParameters: ChecktokApiStoryReactionDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).storyReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * checktok delete comment
     * @param {ChecktokApiV2ApiChecktokCommentsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public v2ApiChecktokCommentsDelete(requestParameters: ChecktokApiV2ApiChecktokCommentsDeleteRequest, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).v2ApiChecktokCommentsDelete(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a tracking entry for checktok
     * @param {ChecktokApiV2ChecktokTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecktokApi
     */
    public v2ChecktokTracking(requestParameters: ChecktokApiV2ChecktokTrackingRequest = {}, options?: RawAxiosRequestConfig) {
        return ChecktokApiFp(this.configuration).v2ChecktokTracking(requestParameters.c24session, requestParameters.checktokTrackingEvent, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ChecktokReportClassificationsReportClassTypeEnum = {
    General: 'GENERAL',
    Content: 'CONTENT',
    User: 'USER'
} as const;
export type ChecktokReportClassificationsReportClassTypeEnum = typeof ChecktokReportClassificationsReportClassTypeEnum[keyof typeof ChecktokReportClassificationsReportClassTypeEnum];


